module.exports = __webpack_public_path__ + "img/Group.1f4873c0.png";